
// pages/Clients/AddEditClient.jsx
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import Select from 'react-select';
import axios from 'axios';
import moment from 'moment-timezone';
import {
  createfullClient,
  editfullProhib,
  editfullClient,
  selectOffices,
  selectDevices,
  selectUsers,
  selectFullClients,
  fetchdealerUsers,
  fetchUsers,
  fetchOffices,
  fetchDevices,
  fetchdealerOffices,
  fetchdealerDevices,
  selectDealerOffices,
} from '../../features/clients/clientsSlice';
import { fetchdealerfullClientsAPI, stateTimezones } from '../../features/clients/clientsAPI';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ClientAgreements, { SignatureField } from './ClientForms/ClientAgreements';
import InstallationForm from './installationform';
import FormPdfPreview from './formpdfpreview';
import { savePaymentAgreement } from './ClientForms/savePaymentAgreement';


const AddEditClient = ({ isOpen, onClose, onSave, clientData, title, user }) => {
  const dispatch = useDispatch();
  const offices = useSelector(selectOffices);
  const dealerOffices = useSelector(selectDealerOffices);
  const devices = useSelector(selectDevices);
  const users = useSelector(selectUsers);
  const fullClients = useSelector(selectFullClients);

  // Stepper & UI States
  const [stepperStep, setStepperStep] = useState(1);
  const [invoiceAuthSignature, setInvoiceAuthSignature] = useState('/rampalyam.png');
  const [invoiceClientSignature, setInvoiceClientSignature] = useState('');
  const invoiceSignatureEditedRef = useRef(false);
  const [invoiceSavedSnapshot, setInvoiceSavedSnapshot] = useState('');
  const [invoiceRevision, setInvoiceRevision] = useState(0);
  const [invoiceSaving, setInvoiceSaving] = useState(false);
  const invoiceSavingRef = useRef(false);
  const [invoiceMessage, setInvoiceMessage] = useState(null);
  useEffect(() => {
    if (!invoiceMessage || invoiceMessage.error) return undefined;
    const timer = setTimeout(() => setInvoiceMessage(null), 5000);
    return () => clearTimeout(timer);
  }, [invoiceMessage]);
  const formBodyRef = useRef(null);
  useEffect(() => {
    if (formBodyRef.current) formBodyRef.current.scrollTop = 0;
  }, [stepperStep]);
  const [installationSaved, setInstallationSaved] = useState(false);
  const [officeDealer, setOfficeDealer] = useState(null);
  const [stepperAddInvoice, setStepperAddInvoice] = useState(false);
  const [prices, setPrices] = useState([]);
  const [selectedPrice, setSelectedPrice] = useState('');
  const [customPrice, setCustomPrice] = useState('');
  const [priceDialog, setPriceDialog] = useState(false);
  const [stepperLoading, setStepperLoading] = useState(false);

  const [acsClientId, setAcsClientId] = useState(null);
  const acsCreationRef = useRef({ created: false, previousIds: [] });
  const acsSavingRef = useRef(false);

  // Payment charge defaults
  const [installationCharges, setInstallationCharges] = useState('0');
  const [deviceUsage, setDeviceUsage] = useState('0');
  const [calibrationCharges, setCalibrationCharges] = useState('0');
  const [deviceLost, setDeviceLost] = useState('600');
  const [physicalDamage, setPhysicalDamage] = useState('300');
  const [latePaymentfee, setLatePaymentfee] = useState('20');
  const [enableInsurancePayment, setEnableInsurancePayment] = useState(false);
  const [insurancePaymentfee, setInsurancePaymentfee] = useState('0');
  const [removalCharges, setRemovalCharges] = useState('0');

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [validationMessage, setValidationMessage] = useState('');
  const [phoneCountryCode, setPhoneCountryCode] = useState('+91');
  const [quickAdd, setQuickAdd] = useState(false);
  const [quickDialog, setQuickDialog] = useState(false);
  const [quickFacility, setQuickFacility] = useState('');
  const [quickDevice, setQuickDevice] = useState('');
  const [showQuickDeviceDropdown, setShowQuickDeviceDropdown] = useState(false);

  // Refs for click outside handling
  const officeDropdownRef = useRef(null);
  const deviceDropdownRef = useRef(null);
  const installerDropdownRef = useRef(null);
  const shouldAutoSelectInstallerRef = useRef(false);

  // Search states for dropdowns
  const [officeSearchTerm, setOfficeSearchTerm] = useState('');
  const [deviceSearchTerm, setDeviceSearchTerm] = useState('');
  const [installerSearchTerm, setInstallerSearchTerm] = useState('');
  const [showOfficeDropdown, setShowOfficeDropdown] = useState(false);
  const [showDeviceDropdown, setShowDeviceDropdown] = useState(false);
  const [showInstallerDropdown, setShowInstallerDropdown] = useState(false);

  // Determine if we're in edit mode
  const isEditMode = !!clientData?.id;
  const loggedInUser = JSON.parse(localStorage.getItem('admin_user') || '{}');
  const isAdmin = loggedInUser?.role === "Admin" || loggedInUser?.role === "superadmin";

  const availableOffices = isAdmin ? offices : dealerOffices;

  // States list
  const staticStates = [
    "ALLL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DC", "DE", "FL", "GA",
    "GU", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME",
    "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV",
    "NY", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VA",
    "VI", "VT", "WA", "WI", "WV", "WY", "INDIA"
  ];
  const [states, setStates] = useState([]);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await fetch('https://alcobrakeadmin.com/v3/v2/states/getstates');
        const data = await response.json();
        setStates(data);
      } catch (error) {
        console.error('Error fetching states:', error);
        setStates(staticStates.map(st => ({ state: st, name: st })));
      }
    };
    fetchStates();
  }, []);



  const calibrationPeriods = ['30', '60', '90'];

  const getChargeValue = (value) => value === '' ? '0' : String(value);

  // Filtered dropdown options
  const filteredOffices = useMemo(() => {
    const list = isAdmin ? offices : (dealerOffices.length > 0 ? dealerOffices : offices);
    if (!officeSearchTerm) return list;
    return list.filter(office =>
      office.officeName?.toLowerCase().includes(officeSearchTerm.toLowerCase())
    );
  }, [offices, dealerOffices, officeSearchTerm, isAdmin]);

  const filteredDevices = useMemo(() => {
    if (!deviceSearchTerm) return devices;
    return devices.filter(device =>
      device.sno?.toLowerCase().includes(deviceSearchTerm.toLowerCase())
    );
  }, [devices, deviceSearchTerm]);

  const filteredQuickDevices = useMemo(() => {
    const search = quickDevice.trim().toLowerCase();
    if (!search) return devices;
    return devices.filter(device => device.sno?.toLowerCase().includes(search));
  }, [devices, quickDevice]);

  const filteredUsers = useMemo(() => {
    if (!installerSearchTerm) return users;
    return users.filter(user =>
      user.userName?.toLowerCase().includes(installerSearchTerm.toLowerCase())
    );
  }, [users, installerSearchTerm]);

  // Form data state
  const [formData, setFormData] = useState({
    id: '',
    client: '',
    clientphone1: '',
    email: '',
    dob: '',
    dlnum: '',
    clientAddress: '',
    space: '',
    city: '',
    state: '',
    zipcode: '',
    officeId: '',
    officeName: '',
    sno: '',
    regnum: '',
    tagstate: '',
    calibrationperiod: '',
    installDate: '',
    calibrationDate: '',
    nextcmonitordate: '',
    installer: '',
    installerName: '',
    imobile: '',
    isinstalledandworking: '1',
    driverisincompliance: '1',
    status: 'Active',
    manufacturer: 'Alcobrake',
    dealer: '',
    officelicensenumber: '',
    isbar: '0',
    faddress: '',
    fcity: '',
    fstate: '',
    fzipcode: '',
    make: '',
    model: '',
    year: '',
    vin: '',
    prohibitionnumber: '',
  });

  const onboardingDealerId = String(officeDealer?.officeId) === String(formData.officeId)
    ? officeDealer.dealerId : !isAdmin ? user?.dealerId : null;

  const invoiceSnapshot = JSON.stringify({ acsClientId, onboardingDealerId, client: formData, stepperAddInvoice, selectedPrice,
    installationCharges, deviceUsage, calibrationCharges, deviceLost, physicalDamage, latePaymentfee,
    insurancePaymentfee, removalCharges, enableInsurancePayment, invoiceAuthSignature, invoiceClientSignature });
  const invoiceSaved = invoiceSavedSnapshot === invoiceSnapshot;

  const installationClient = useMemo(() => ({ ...formData, id: acsClientId }), [formData, acsClientId]);

  const formatPriceDisplay = useCallback((price) => {
    const amount = price?.unit_amount ?? price?.unitAmount ?? price?.amount ?? price?.price;
    const currency = (price?.currency || '$').toUpperCase();
    const numericAmount = Number(amount);

    if (Number.isNaN(numericAmount)) {
      return price?.display || price?.nickname || price?.id || 'Price plan';
    }

    return `${currency} ${(numericAmount / 100).toFixed(2)}`;
  }, []);

  const fetchProductprices = useCallback(async () => {
    try {
      const res = await axios.get(
        "https://alcobrakeadmin.com/v3/v2/stripepayments/getpricelist",
        {
          params: {
            product: "prod_TTSP204gryENNh",
          }
        }
      );

      const priceList = res.data?.data || res.data?.prices || res.data || [];
      const normalizedPrices = Array.isArray(priceList)
        ? priceList
            .filter(price => price?.id)
            .map(price => ({
              ...price,
              display: price.display || formatPriceDisplay(price)
            }))
        : [];

      setPrices(normalizedPrices);
    } catch (err) {
      console.error("Error fetching product prices:", err);
      setPrices([]);
    }
  }, [formatPriceDisplay]);

  // Create new Stripe Price plan
  const createNewPrice = async () => {
    try {
      if (!customPrice) {
        Swal.fire({
          title: 'Error',
          text: 'Enter price',
          icon: 'error',
          timer: 2000,
          showConfirmButton: false
        });
        return;
      }

      const res = await axios.post(
        "https://alcobrakeadmin.com/v3/v2/stripepayments/addpriceproducts",
        {
          unit_amount: String(customPrice),
          currency: "usd",
          product: "prod_TTSP204gryENNh",
          mode: "live"
        }
      );
      console.log("ADD PRICE RESPONSE", res.data);

      await fetchProductprices();

      const newPriceId = res.data.id || res.data.data?.id;
      if (newPriceId) {
        setSelectedPrice(newPriceId);
      }

      setCustomPrice('');
      setPriceDialog(false);

      Swal.fire({
        title: 'Success!',
        text: 'Price added successfully',
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        title: 'Error',
        text: 'Failed to add price',
        icon: 'error',
        timer: 2000,
        showConfirmButton: false
      });
    }
  };

  // Populate form when clientData is provided (Edit mode) or Reset on Add mode
  useEffect(() => {
    if (isOpen) {
      setStepperStep(1);
      setInvoiceAuthSignature('/rampalyam.png');
      setInvoiceClientSignature('');
      invoiceSignatureEditedRef.current = false;
      setInvoiceSavedSnapshot('');
      setInvoiceRevision(0);
      setInvoiceMessage(null);
      setInstallationSaved(false);
      setOfficeDealer(null);
      setAcsClientId(null);
      acsCreationRef.current = { created: false, previousIds: [] };
      setStepperAddInvoice(false);
      setSelectedPrice('');
      setCustomPrice('');
      setPriceDialog(false);
      setInstallationCharges('0');
      setDeviceUsage('0');
      setCalibrationCharges('0');
      setDeviceLost('600');
      setPhysicalDamage('300');
      setLatePaymentfee('20');
      setEnableInsurancePayment(false);
      setInsurancePaymentfee('0');
      setRemovalCharges('0');

      if (!clientData?.id) {
        fetchProductprices();

  // Ensure prices are fetched when Add Invoice is enabled

      }

      if (clientData) {
        console.log("Received clientData for edit:", clientData);
        populateFormFromClient(clientData);
      } else {
        resetForm();
      }
    }
  }, [isOpen, clientData, user?.dealerId, fetchProductprices]);

  // Ensure prices are fetched when Add Invoice is enabled
  useEffect(() => {
    if (stepperAddInvoice) {
      setSelectedPrice('');
      setPrices([]);
      fetchProductprices();
    }
  }, [stepperAddInvoice, user, fetchProductprices]);

  // Fetch offices and devices on modal open
  useEffect(() => {
    if (isOpen) {
      if (isAdmin) {
        dispatch(fetchOffices());
        dispatch(fetchDevices());
        if (isEditMode) {
          dispatch(fetchUsers());
        }
      } else if (user?.dealerId) {
        dispatch(fetchdealerOffices(user.dealerId));
        dispatch(fetchdealerDevices(user.dealerId));
        dispatch(fetchdealerUsers(user.dealerId));
      }
    }
  }, [isOpen, isAdmin, user, dispatch, isEditMode]);

  // Reset dropdown states when modal closes
  useEffect(() => {
    if (!isOpen) {
      setOfficeSearchTerm('');
      setDeviceSearchTerm('');
      setInstallerSearchTerm('');
      setShowOfficeDropdown(false);
      setShowDeviceDropdown(false);
      setShowInstallerDropdown(false);
      setQuickAdd(false);
      setQuickDialog(false);
      setQuickFacility('');
      setQuickDevice('');
      setShowQuickDeviceDropdown(false);
    }
  }, [isOpen]);

  // Handle click outside to close dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (officeDropdownRef.current && !officeDropdownRef.current.contains(event.target)) {
        setShowOfficeDropdown(false);
      }
      if (deviceDropdownRef.current && !deviceDropdownRef.current.contains(event.target)) {
        setShowDeviceDropdown(false);
      }
      if (installerDropdownRef.current && !installerDropdownRef.current.contains(event.target)) {
        setShowInstallerDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Fetch Installers and Facility Details based on selected Office/Facility
  useEffect(() => {
    const fetchInstallersForOffice = async () => {
      if (formData.officeId && isOpen) {
        try {
          const officeResponse = await fetch(`https://alcobrakeadmin.com/v3/us/caoffices/getuniqueoffice?officeId=${formData.officeId}`);
          const officeData = await officeResponse.json();

          if (officeData && officeData[0]) {
            const dealerId = officeData[0].dealerId;
            setOfficeDealer({ officeId: formData.officeId, dealerId });
            const dealerName = officeData[0].dealerName;
            const officeName = officeData[0].officeName;
            const officeLic = officeData[0].officelicensenumber || officeData[0].licensenumber || '';
            const officeIsBar = officeData[0].isbar || officeData[0].isBar || '0';
            const officeAddress = officeData[0].faddress || officeData[0].address || '';
            const officeCity = officeData[0].fcity || officeData[0].city || '';
            const officeState = officeData[0].fstate || officeData[0].state || '';
            const officeZip = officeData[0].fzipcode || officeData[0].zipcode || '';

            console.log(`Office selected: ${officeName}, Dealer: ${dealerName}, Dealer ID: ${dealerId}`);

            setFormData(prev => ({
              ...prev,
              dealer: dealerName,
              officeName: officeName,
              officelicensenumber: officeLic,
              isbar: officeIsBar,
              faddress: officeAddress,
              fcity: officeCity,
              fstate: officeState,
              fzipcode: officeZip
            }));

            const dealerUsers = await dispatch(fetchdealerUsers(dealerId)).unwrap();
            if (shouldAutoSelectInstallerRef.current) {
              const firstInstaller = Array.isArray(dealerUsers) ? dealerUsers[0] : null;
              setFormData(prev => ({
                ...prev,
                installer: firstInstaller?.userId || '',
                installerName: firstInstaller?.userName || '',
                imobile: firstInstaller?.userMobile1 || ''
              }));
              setInstallerSearchTerm(firstInstaller?.userName || '');
              shouldAutoSelectInstallerRef.current = false;
            }
          }
        } catch (error) {
          console.error("Error fetching officer details:", error);
          shouldAutoSelectInstallerRef.current = false;
        }
      }
    };

    fetchInstallersForOffice();
  }, [formData.officeId, dispatch, isOpen]);

  // Automatically compute nextcmonitordate and calibrationDate when installDate or calibrationperiod changes
  useEffect(() => {
    if (formData.installDate && formData.calibrationperiod) {
      const installMoment = moment(formData.installDate, 'MM/DD/YYYY');
      if (installMoment.isValid()) {
        const calPeriod = parseInt(formData.calibrationperiod, 10);
        const nextMonitorDate = installMoment.clone().add(calPeriod, 'days');

        setFormData(prev => ({
          ...prev,
          calibrationDate: formData.installDate,
          nextcmonitordate: nextMonitorDate.format('MM/DD/YYYY')
        }));
      }
    }
  }, [formData.installDate, formData.calibrationperiod]);

  // For Admin users - fetch all users when in add mode without office selected
  useEffect(() => {
    if (isOpen && !formData.officeId && isAdmin && !isEditMode) {
      console.log("Admin add mode - fetching all users");
      dispatch(fetchUsers());
    }
  }, [isOpen, formData.officeId, isEditMode, isAdmin, dispatch]);

  const resetForm = () => {
    setPhoneCountryCode('+91');
    setFormData({
      id: '',
      client: '',
      clientphone1: '',
      email: '',
      dob: '',
      dlnum: '',
      clientAddress: '',
      space: '',
      city: '',
      state: '',
      zipcode: '',
      officeId: '',
      officeName: '',
      sno: '',
      regnum: '',
      tagstate: '',
      calibrationperiod: '',
      installDate: '',
      calibrationDate: '',
      nextcmonitordate: '',
      installer: '',
      installerName: '',
      imobile: '',
      isinstalledandworking: '1',
      driverisincompliance: '1',
      status: 'Active',
      manufacturer: 'Alcobrake',
      dealer: '',
      officelicensenumber: '',
      isbar: '0',
      faddress: '',
      fcity: '',
      fstate: '',
      fzipcode: '',
    });
    setErrors({});
    setOfficeSearchTerm('');
    setDeviceSearchTerm('');
    setInstallerSearchTerm('');
    setShowOfficeDropdown(false);
    setShowDeviceDropdown(false);
    setShowInstallerDropdown(false);
  };

  // Format phone number (remove non-digits)
  const formatPhone = (phone) => {
    if (!phone) return '';
    return phone.replace(/\D/g, '');
  };

  // The country code is displayed separately and is never included in the
  // value submitted to the existing client API.
  const splitPhoneForDisplay = (phone) => {
    const digits = formatPhone(phone);
    if (digits.length <= 10) return { countryCode: '+91', localNumber: digits };

    return {
      countryCode: `+${digits.slice(0, -10)}`,
      localNumber: digits.slice(-10)
    };
  };

  const formatCity = (city) => String(city || '').replace(/[^a-zA-Z\s.'-]/g, '');

  // Convert API date (MMDDYYYY) to display date (MM/DD/YYYY)
  const apiToDisplayDate = (date) => {
    if (!date) return '';
    if (/^\d{8}$/.test(date)) {
      const month = date.substring(0, 2);
      const day = date.substring(2, 4);
      const year = date.substring(4, 8);
      return `${month}/${day}/${year}`;
    }
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
      return date;
    }
    return date;
  };

  const parseMMDDYYYY = (dateString) => {
    if (!dateString) return null;
    const parts = dateString.split('/');
    if (parts.length !== 3) return null;
    const [month, day, year] = parts;
    return new Date(year, month - 1, day);
  };

  const formatMMDDYYYY = (date) => {
    if (!date) return '';
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const formatDateTimeForAPI = (date = new Date()) => {
    return moment(date).format('MM/DD/YYYY HH:mm:ss');
  };

  const formatDateForStorage = (date) => {
    if (!date) return '';
    if (/^\d{8}$/.test(date)) {
      return apiToDisplayDate(date);
    }
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
      const [month, day, year] = date.split('/');
      return `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year}`;
    }
    return date;
  };

  const getCalibrationDates = (installDate, calibrationperiod) => {
    if (!installDate || !calibrationperiod) {
      return {
        calibrationDate: '',
        nextcmonitordate: ''
      };
    }

    const installMoment = moment(installDate, 'MM/DD/YYYY');
    if (!installMoment.isValid()) {
      return {
        calibrationDate: '',
        nextcmonitordate: ''
      };
    }

    return {
      calibrationDate: installMoment.format('MM/DD/YYYY'),
      nextcmonitordate: installMoment.clone().add(parseInt(calibrationperiod, 10), 'days').format('MM/DD/YYYY')
    };
  };

  // Format date for API (handles MM/DD/YYYY to MMDDYYYY)
  const formatDateForAPI = (date) => {
    if (!date) return '';
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
      const [month, day, year] = date.split('/');
      return `${month.padStart(2, '0')}${day.padStart(2, '0')}${year}`;
    }
    return date;
  };

  // Populate form from client data
  const populateFormFromClient = (item) => {
    let installerName = '';
    let installerMobile = '';
    if (item.installer) {
      const installerUser = users.find(u => String(u.userId) === String(item.installer));
      if (installerUser) {
        installerName = installerUser.userName;
        installerMobile = installerUser.userMobile1 || '';
      }
    }

    let officeName = '';
    if (item.officeId) {
      const list = isAdmin ? offices : (dealerOffices.length > 0 ? dealerOffices : offices);
      const office = list.find(o => String(o.officeId) === String(item.officeId));
      if (office) {
        officeName = office.officeName;
      }
    }

    const phone = splitPhoneForDisplay(item.clientphone1 || '');
    setPhoneCountryCode(phone.countryCode);

    setFormData({
      id: item.id || '',
      client: item.client || '',
      clientphone1: phone.localNumber,
      email: item.email || '',
      dob: apiToDisplayDate(item.dob || ''),
      dlnum: item.DLnum || item.dlnum || '',
      clientAddress: item.clientAddress || '',
      space: item.space || '',
      city: item.city || '',
      state: item.state || '',
      zipcode: item.zipcode || '',
      officeId: item.officeId || '',
      officeName: officeName,
      sno: item.sno || '',
      regnum: item.regnum || '',
      tagstate: item.tagstate || '',
      calibrationperiod: item.calibrationperiod || '',
      installDate: apiToDisplayDate(item.installDate || ''),
      calibrationDate: apiToDisplayDate(item.calibrationDate || ''),
      nextcmonitordate: apiToDisplayDate(item.nextcmonitordate || ''),
      installer: item.installer || '',
      installerName: installerName,
      imobile: installerMobile,
      isinstalledandworking: item.isinstalledandworking ? String(item.isinstalledandworking) : '1',
      driverisincompliance: item.driverisincompliance ? String(item.driverisincompliance) : '1',
      status: item.status || 'Active',
      manufacturer: item.manufacturer || 'Alcobrake',
      dealer: item.dealer || '',
      officelicensenumber: item.officelicensenumber || '',
      isbar: item.isbar || '0',
      faddress: item.faddress || '',
      fcity: item.fcity || '',
      fstate: item.fstate || '',
      fzipcode: item.fzipcode || '',
      make: item.make || '',
      model: item.model || '',
      year: item.year || '',
      vin: item.vin || '',
      prohibitionnumber: item.prohibitionnumber || '',
    });

    if (officeName) setOfficeSearchTerm(officeName);
    if (item.sno) setDeviceSearchTerm(item.sno);
    if (installerName) setInstallerSearchTerm(installerName);
  };

  // Form validations for Step 1
  const isDeviceAlreadyAssigned = (sno) => (
    !isEditMode &&
    !!sno &&
    Array.isArray(fullClients) &&
    fullClients.some(driver => String(driver.sno) === String(sno) && String(driver.id) !== String(acsClientId))
  );

  const validateForm = () => {
    const newErrors = {};

    if (isEditMode) {
      if (formData.clientphone1 && !/^\d{10}$/.test(formData.clientphone1)) {
        newErrors.clientphone1 = 'Enter valid phone number';
      }
      if (formData.email && !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(formData.email)) {
        newErrors.email = 'E-mail must be valid';
      }
      if (formData.zipcode && formData.zipcode.length !== 5 && formData.zipcode.length !== 0) {
        newErrors.zipcode = 'Enter valid zip code';
      }
      if (formData.regnum && (formData.regnum.length < 5 || formData.regnum.length > 15)) {
        newErrors.regnum = 'Enter valid plate';
      }
      // if (formData.dlnum && formData.dlnum.length < 8) {
      //   newErrors.dlnum = 'Enter valid DL';
      // }
    } else {
      if (!formData.client) newErrors.client = 'Name is required';
      else if (formData.client.length < 5) newErrors.client = 'Name must contain 5 or more characters';

      // if (!formData.clientphone1) newErrors.clientphone1 = 'Home Telephone Required';
      // else if (!/^\d{10}$/.test(formData.clientphone1)) newErrors.clientphone1 = 'Enter valid phone number';

      // if (formData.email && !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(formData.email)) {
      //   newErrors.email = 'E-mail must be valid';
      // }

      // if (!formData.dob) newErrors.dob = 'Birth Date is required';
      // if (!formData.state) newErrors.state = 'Select State';

      // if (!formData.zipcode) newErrors.zipcode = 'Zip is required';
      // else if (formData.zipcode.length !== 5) newErrors.zipcode = 'Enter valid zip code';

      if (!formData.officeId) newErrors.officeId = 'Select Facility';
      if (!formData.sno) newErrors.sno = 'Device Id is required';
      else if (isDeviceAlreadyAssigned(formData.sno)) {
        newErrors.sno = 'This Number already exists use different one';
      }

      // if (!formData.regnum) newErrors.regnum = 'Plate number is required';
      // else if (formData.regnum.length < 5 || formData.regnum.length > 15) newErrors.regnum = 'Enter valid plate';

      // if (!formData.tagstate) newErrors.tagstate = 'Select Tag State';
      // if (!formData.dlnum) newErrors.dlnum = 'DL Number is required';
      // else if (formData.dlnum.length < 8) newErrors.dlnum = 'Enter valid DL';

      if (!formData.installDate) newErrors.installDate = 'Select Install date';
      // if (!formData.calibrationperiod) newErrors.calibrationperiod = 'Select Calibration Period';
      // if (!formData.installer) newErrors.installer = 'Select Installer';
    }

    console.log("UPDATE DEBUG validateForm errors:", newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Prepare form data for API
  const prepareFormData = () => {
    const fd = new FormData();

    fd.append("id", formData.id);
    fd.append("isresidsame", "1");
    fd.append("manufacturer", "Alcobrake");
    fd.append("isinstalledandworking", formData.isinstalledandworking);
    fd.append("driverisincompliance", formData.driverisincompliance);
    fd.append("isunavailablevehicle", "0");
    fd.append("installer", formData.installer);
    fd.append("suffix", "");
    fd.append("space", formData.space);

    // Residential address (same as mailing address)
    fd.append("rclientAddress", formData.clientAddress);
    fd.append("rspace", formData.space);
    fd.append("rcity", formData.city);
    fd.append("rstate", formData.state);
    fd.append("rzipcode", formData.zipcode);

    fd.append("uregnum", "");
    fd.append("umake", "");
    fd.append("uyear", "");
    fd.append("uvin", "");
    fd.append("client", formData.client);
    fd.append("office", formData.officeId);
    fd.append("officeId", formData.officeId);

    if (!formData.id) {
      fd.append("regdate", formatDateTimeForAPI());
    } else {
      fd.append("regdate", formData.regdate || "");
    }

    fd.append("clientphone1", formatPhone(formData.clientphone1));
    fd.append("clientphone2", "");
    fd.append("email", formData.email);
    fd.append("sno", formData.sno);
    fd.append("clientAddress", formData.clientAddress);
    fd.append("city", formData.city);
    fd.append("state", formData.state);
    fd.append("zipcode", formData.zipcode);
    fd.append("regnum", formData.regnum);
    fd.append("installDate", formatDateForStorage(formData.installDate));
    fd.append("calibrationDate", formatDateForStorage(formData.calibrationDate));
    fd.append("nextcmonitordate", formatDateForStorage(formData.nextcmonitordate));
    fd.append("make", formData.make || "");
    fd.append("dob", formatDateForAPI(formData.dob));
    fd.append("model", formData.model || "");
    fd.append("year", formData.year || "");
    fd.append("color", "");
    fd.append("vin", formData.vin || "");
    fd.append("tag", "");
    fd.append("tagstate", formData.tagstate);
    fd.append("dlnum", formData.dlnum);
    fd.append("DLnum", formData.dlnum);
    fd.append("prohibitionnumber", "");

    fd.append("prohibstart", formatDateForStorage(formData.installDate));
    fd.append("prohibStart", formatDateForStorage(formData.installDate));
    fd.append("prohibend", "");
    fd.append("conviction", "");
    fd.append("calibrationperiod", formData.calibrationperiod);
    fd.append("issms", "0");
    fd.append("facedetection", "0");

    return fd;
  };

  const logEditDebug = (fd) => {
    if (!formData.id) return;

    const keys = [
      "id",
      "client",
      "office",
      "officeId",
      "clientphone1",
      "email",
      "dob",
      "dlnum",
      "DLnum",
      "installDate",
      "calibrationDate",
      "nextcmonitordate",
      "prohibstart",
      "calibrationperiod",
      "installer"
    ];

    console.log("EDIT DEBUG formData:", {
      id: formData.id,
      client: formData.client,
      dob: formData.dob,
      dlnum: formData.dlnum,
      installDate: formData.installDate,
      calibrationDate: formData.calibrationDate,
      nextcmonitordate: formData.nextcmonitordate,
      calibrationperiod: formData.calibrationperiod,
      installer: formData.installer
    });
    console.log("EDIT DEBUG payload:", Object.fromEntries(keys.map(key => [key, fd.get(key)])));
  };

const saveInvoice = async () => {
    if (!selectedPrice) {
    alert('Please select a price plan.');
    return;
  }
    if (invoiceSavingRef.current) return;
    setInvoiceMessage(null);
    if (!acsClientId || !onboardingDealerId) return setInvoiceMessage({ error: true, text: 'Save client details first.' });
    if (!invoiceAuthSignature || !invoiceClientSignature) return setInvoiceMessage({ error: true, text: 'Add authorization and client signatures before saving.' });
    if (stepperAddInvoice && !selectedPrice) return setInvoiceMessage({ error: true, text: 'Select a price plan before saving.' });
    const charges = { installationcharges: installationCharges, device_usage_fee: deviceUsage,
      calibration_charges: calibrationCharges, device_lost: deviceLost, physical_damage: physicalDamage,
      late_payment_fee: latePaymentfee, insurance_payment_fee: insurancePaymentfee, removalcharges: removalCharges };
    if (Object.values(charges).some(value => value === '' || !Number.isFinite(Number(value)) || Number(value) < 0)) {
      return setInvoiceMessage({ error: true, text: 'Enter a valid non-negative amount for each charge.' });
    }
    invoiceSavingRef.current = true;
    setInvoiceSaving(true);
    try {
      await savePaymentAgreement({ clientid: acsClientId, dealerid: onboardingDealerId, charges,
        authSignature: invoiceAuthSignature, clientSignature: invoiceClientSignature, insurance: enableInsurancePayment });
      setInvoiceSavedSnapshot(invoiceSnapshot);
      setInvoiceRevision(Date.now());
      setInvoiceMessage({ text: 'Invoice agreement saved successfully.' });
    } catch (error) {
      setInvoiceMessage({ error: true, text: error.response?.data?.message || error.message || 'Unable to save invoice agreement.' });
    } finally {
      invoiceSavingRef.current = false;
      setInvoiceSaving(false);
    }
  };

const goToStep2 = async () => {
    if (acsSavingRef.current) return;
    if (!onboardingDealerId) {
      setValidationMessage('Select a facility and wait for its dealer details to load before continuing.');
      return;
    }
    if (!validateForm()) {
      setValidationMessage('Please correct the highlighted fields before continuing.');
      return;
    }
    acsSavingRef.current = true;
    setStepperLoading(true);
    setValidationMessage('');
    try {
      const fd = prepareFormData();
      if (acsClientId) {
        fd.set('id', acsClientId);
        await dispatch(editfullProhib({ cdata: fd, id: acsClientId })).unwrap();
        await dispatch(editfullClient({ cdata: fd, id: acsClientId })).unwrap();
      } else {
        if (!acsCreationRef.current.created) {
          const before = await fetchdealerfullClientsAPI(onboardingDealerId);
          acsCreationRef.current.previousIds = before.map(item => String(item.id));
          const response = await dispatch(createfullClient(fd)).unwrap();
          acsCreationRef.current.created = true;
          const id = response?.clientid || response?.id || response?.data?.clientid || response?.data?.id;
          if (id && Number(id) > 0) acsCreationRef.current.id = id;
        }
        let id = acsCreationRef.current.id;
        if (!id) {
          const latest = await fetchdealerfullClientsAPI(onboardingDealerId);
          const candidates = latest.filter(item =>
            !acsCreationRef.current.previousIds.includes(String(item.id)) &&
            String(item.client || '').trim() === formData.client.trim() &&
            String(item.email || '').trim().toLowerCase() === formData.email.trim().toLowerCase()
          );
          if (candidates.length !== 1) throw new Error('Client was created, but its ID could not be uniquely resolved. Retry to load the saved client; no duplicate will be created.');
          id = candidates[0].id;
        }
        setAcsClientId(id);
      }
      setStepperStep(2);
      setInstallationSaved(false);
    } catch (error) {
      setValidationMessage(typeof error === 'string' ? error : error.message || 'Unable to save client details.');
    } finally {
      setStepperLoading(false);
      acsSavingRef.current = false;
    }
  };
  const goToStep3 = () => {
  setValidationMessage('');
  setStepperStep(3);
};

  const goToStep4 = () => {
    if (!invoiceSaved) return;
    if (stepperAddInvoice && !selectedPrice) {
      setValidationMessage('Select a price plan before continuing.');
      return;
    }
    setValidationMessage('');
    setStepperStep(5);
  };

  const submitStepper = async (e) => {
    if (e) e.preventDefault();
    if (!isEditMode && acsClientId && !invoiceSaved) {
      setValidationMessage('Save the invoice agreement before completing onboarding.');
      return;
    }

    console.log("UPDATE DEBUG clicked:", {
      isEditMode: !!formData.id,
      id: formData.id,
      client: formData.client
    });

    if (!validateForm()) {
      console.log("UPDATE DEBUG validation failed:", errors);
      setValidationMessage('Please correct the highlighted fields before saving.');
      return;
    }
    setValidationMessage('');

    setStepperLoading(true);

    try {
      const fd = prepareFormData();
      console.log("UPDATE DEBUG prepared payload keys:", Array.from(fd.keys()));

      if (formData.id || acsClientId) {
        const savedClientId = formData.id || acsClientId;
        fd.set('id', savedClientId);
        // Edit mode
        logEditDebug(fd);
        const prohibResponse = await dispatch(editfullProhib({ cdata: fd, id: formData.id || acsClientId })).unwrap();
        console.log("EDIT DEBUG editfullProhib response:", prohibResponse);
        const clientResponse = await dispatch(editfullClient({ cdata: fd, id: formData.id || acsClientId })).unwrap();
        console.log("EDIT DEBUG editfullClient response:", clientResponse);
      } else {
        // Add mode
        await dispatch(createfullClient(fd)).unwrap();
      }

      Swal.fire({ title: 'Success!', text: isEditMode ? 'Client updated successfully' : 'Client onboarding completed successfully', icon: 'success', timer: 2000, showConfirmButton: false });

      onClose();
      if (onSave) onSave();

    } catch (error) {
      console.error("Save error:", error);
      console.log("UPDATE DEBUG failed:", {
        message: error?.message,
        error
      });
      Swal.fire({
        title: 'Error',
        text: typeof error === 'string' ? error : (error.message || 'Failed to save client'),
        icon: 'error'
      });
    } finally {
      setStepperLoading(false);
    }
  };

  const handleTagStateChange = (e) => {
    const selectedStateValue = e.target.value;
    const stateObj = states.find(st => (st.state || st) === selectedStateValue);

    setFormData(prev => {
      const installDate = prev.installDate || formatMMDDYYYY(new Date());
      const calPeriod = (stateObj && stateObj.calibrationperiod) ? String(stateObj.calibrationperiod) : prev.calibrationperiod;

      const computedDates = calPeriod ? getCalibrationDates(installDate, calPeriod) : {
        calibrationDate: '',
        nextcmonitordate: ''
      };

      return {
        ...prev,
        tagstate: selectedStateValue,
        calibrationperiod: calPeriod,
        installDate: calPeriod ? installDate : prev.installDate,
        ...computedDates
      };
    });

    if (validationMessage) setValidationMessage('');
    if (errors.tagstate) {
      setErrors(prev => ({ ...prev, tagstate: '' }));
    }
    if (errors.calibrationperiod) {
      setErrors(prev => ({ ...prev, calibrationperiod: '' }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'calibrationperiod') {
      setFormData(prev => {
        const installDate = prev.installDate || formatMMDDYYYY(new Date());
        const computedDates = value ? getCalibrationDates(installDate, value) : {
          calibrationDate: '',
          nextcmonitordate: ''
        };

        return {
          ...prev,
          calibrationperiod: value,
          installDate: value ? installDate : prev.installDate,
          ...computedDates
        };
      });
      if (errors[name]) {
        setErrors(prev => ({ ...prev, [name]: '' }));
      }
      return;
    }

    const sanitizedValue = name === 'clientphone1'
      ? formatPhone(value).slice(0, 10)
      : name === 'zipcode' || name === 'fzipcode'
        ? formatPhone(value).slice(0, 5)
        : name === 'city' || name === 'fcity'
          ? formatCity(value)
          : value;

    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? '1' : '0') : sanitizedValue
    }));
    if (validationMessage) setValidationMessage('');
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleDateChange = (date, fieldName) => {
    if (date) {
      const formattedDate = formatMMDDYYYY(date);
      setFormData(prev => ({
        ...prev,
        [fieldName]: formattedDate,
        ...(fieldName === 'installDate' && prev.calibrationperiod
          ? getCalibrationDates(formattedDate, prev.calibrationperiod)
          : {})
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [fieldName]: '',
        ...(fieldName === 'installDate'
          ? { calibrationDate: '', nextcmonitordate: '' }
          : {})
      }));
    }

    if (errors[fieldName]) {
      setErrors(prev => ({
        ...prev,
        [fieldName]: ''
      }));
    }
  };

  const handleInstallerSelect = (userId, userName, userMobile) => {
    setFormData(prev => ({
      ...prev,
      installer: userId,
      installerName: userName,
      imobile: userMobile || ''
    }));
    setInstallerSearchTerm(userName);
    setShowInstallerDropdown(false);
    if (errors.installer) {
      setErrors(prev => ({ ...prev, installer: '' }));
    }
  };

  const handleOfficeSelect = (officeId, officeName) => {
    shouldAutoSelectInstallerRef.current = true;
    setFormData(prev => ({
      ...prev,
      officeId: officeId,
      officeName: officeName,
      installer: '',
      installerName: '',
      imobile: ''
    }));
    setOfficeSearchTerm(officeName);
    setInstallerSearchTerm('');
    setShowOfficeDropdown(false);
    if (errors.officeId) {
      setErrors(prev => ({ ...prev, officeId: '' }));
    }
  };

  const handleDeviceSelect = (sno) => {
    if (isDeviceAlreadyAssigned(sno)) {
      setFormData(prev => ({ ...prev, sno: '' }));
      setDeviceSearchTerm(sno);
      setShowDeviceDropdown(false);
      setErrors(prev => ({ ...prev, sno: 'This Number already exists use different one' }));
      return;
    }

    const match = sno.match(/(INDIA|CA|TX|WI|IL)/);
    setFormData(prev => {
      const updated = { ...prev, sno: sno };
      if (match) {
        updated.state = match[0];
        updated.tagstate = match[0];
        const stateObj = states.find(st => (st.state || st) === match[0]);
        updated.calibrationperiod = stateObj?.calibrationperiod != null ? String(stateObj.calibrationperiod) : '';
        updated.installDate = prev.installDate || formatMMDDYYYY(new Date());
        Object.assign(updated, getCalibrationDates(updated.installDate, updated.calibrationperiod));
      }
      return updated;
    });
    setDeviceSearchTerm(sno);
    setShowDeviceDropdown(false);
    if (errors.sno) {
      setErrors(prev => ({ ...prev, sno: '' }));
    }
  };

  const closeQuickAddDialog = () => {
    setQuickDialog(false);
    setQuickAdd(false);
    setQuickFacility('');
    setQuickDevice('');
    setShowQuickDeviceDropdown(false);
  };

  const handleQuickAdd = (event) => {
    const enabled = event.target.checked;
    setQuickAdd(enabled);
    setQuickDialog(enabled);
  };

  const applyQuickData = () => {
    const office = availableOffices.find(item => String(item.officeId) === String(quickFacility));
    const device = devices.find(item => item.sno === quickDevice);
    if (!office || !device || isDeviceAlreadyAssigned(quickDevice)) return;

    const stateAbbrs = states.map(st => st.state || st);
    const matchedState = [...stateAbbrs]
      .sort((a, b) => b.length - a.length)
      .find(state => quickDevice.toUpperCase().includes(String(state).toUpperCase())) || '';
    const stateObj = states.find(st => (st.state || st).toUpperCase() === matchedState);
    const calibrationperiod = stateObj?.calibrationperiod != null ? String(stateObj.calibrationperiod) : '';
    const timezone = stateTimezones[matchedState || office.state || office.fstate]
      || (moment.tz.zone(device.timezone || '') ? device.timezone : moment.tz.guess());
    const installationToday = moment().tz(timezone).format('MM/DD/YYYY');

    shouldAutoSelectInstallerRef.current = true;
    setFormData(prev => ({
      ...prev,
      officeId: office.officeId,
      officeName: office.officeName,
      sno: quickDevice,
      client: quickDevice.toUpperCase(),
      email: `${quickDevice}@gmail.com`,
      clientphone1: '8977285707',
      dlnum: `DL${quickDevice}`,
      regnum: quickDevice,
      tagstate: matchedState,
      calibrationperiod,
      ...getCalibrationDates(installationToday, calibrationperiod),
      state: matchedState,
      installDate: installationToday,
      installer: '',
      installerName: '',
      imobile: ''
    }));
    setOfficeSearchTerm(office.officeName || '');
    setDeviceSearchTerm(quickDevice);
    setInstallerSearchTerm('');
    setErrors(prev => ({ ...prev, officeId: '', sno: '' }));
    setQuickDialog(false);
    setShowQuickDeviceDropdown(false);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <style>{`
        /* Premium Stepper Styling */
        .client-stepper-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 24px;
          background: #ffffff;
          border-bottom: 1px solid #e2e8f0;
          margin-bottom: 24px;
        }

        .stepper-step {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #64748b;
          font-weight: 500;
          font-size: 14px;
        }

        .stepper-step.active {
          color: #006E6E;
          font-weight: 700;
        }

        .stepper-step.completed {
          color: #10b981;
        }

        .step-num {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background: #e2e8f0;
          color: #64748b;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          font-weight: bold;
          transition: all 0.2s ease;
        }

        .stepper-step.active .step-num {
          background: #006E6E;
          color: #ffffff;
        }

        .stepper-step.completed .step-num {
          background: #10b981;
          color: #ffffff;
        }

        .stepper-line {
          flex: 1;
          height: 2px;
          background: #e2e8f0;
          margin: 0 16px;
        }

        .stepper-line.active {
          background: #006E6E;
        }

        .stepper-line.completed {
          background: #10b981;
        }

        /* Custom pricing container styling */
        .price-config-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 24px;
          margin-bottom: 20px;
        }

        .price-config-title {
          color: #006E6E;
          font-size: 16px;
          font-weight: 700;
          margin-top: 0;
          margin-bottom: 20px;
        }

        .price-select-wrapper {
          margin-bottom: 20px;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .price-select-control {
          display: flex;
          gap: 12px;
        }

        .price-select-input {
          flex: 1;
          padding: 10px 14px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 14px;
          background: #f8fafc;
        }

        .btn-add-price {
          background: #006E6E;
          color: #ffffff;
          border: none;
          padding: 0 16px;
          border-radius: 8px;
          font-weight: 600;
          font-size: 13px;
          cursor: pointer;
          transition: background 0.2s;
        }

        .btn-add-price:hover {
          background: #005656;
        }

        /* Add custom price modal popup styling */
        .price-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.4);
          z-index: 2000;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .price-modal-card {
          background: #ffffff;
          border-radius: 14px;
          width: 90%;
          max-width: 400px;
          overflow: hidden;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        }

        .price-modal-header {
          background: #006E6E;
          color: #ffffff;
          padding: 16px 20px;
          font-size: 16px;
          font-weight: 600;
          margin: 0;
        }

        .price-modal-body {
          padding: 20px;
        }

        .price-modal-body input {
          width: 100%;
          padding: 10px 14px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 14px;
          margin-top: 8px;
        }

        .price-modal-footer {
          padding: 12px 20px;
          background: #f8fafc;
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          border-top: 1px solid #e2e8f0;
        }

        .price-modal-footer button {
          padding: 8px 16px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
        }

        .btn-price-cancel {
          background: transparent;
          border: 1px solid #d1d5db;
          color: #374151;
        }

        .btn-price-save {
          background: #006E6E;
          color: white;
          border: none;
        }

        /* Summary Card styling */
        .summary-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 24px;
          margin-bottom: 20px;
        }

        .summary-title {
          color: #006E6E;
          font-size: 18px;
          font-weight: 700;
          text-align: center;
          margin-top: 0;
          margin-bottom: 24px;
        }

        .summary-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px 24px;
        }

        .summary-item {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .summary-label {
          font-size: 12px;
          color: #64748b;
          font-weight: 500;
        }

        .summary-value {
          font-size: 15px;
          color: #1e293b;
          font-weight: 600;
        }

        .summary-divider {
          grid-column: span 2;
          height: 1px;
          background: #e2e8f0;
          margin: 8px 0;
        }

        /* Checkbox styling alignment */
        .checkbox-group {
          display: flex !important;
          flex-direction: row !important;
          align-items: center !important;
          gap: 12px !important;
          margin-top: 12px !important;
          margin-bottom: 12px !important;
        }

        .checkbox-group label {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          font-size: 14px !important;
          color: #334155 !important;
          cursor: pointer !important;
          font-weight: 500 !important;
          margin: 0 !important;
        }

        .checkbox-group input[type="checkbox"] {
          width: 18px !important;
          height: 18px !important;
          padding: 0 !important;
          margin: 0 !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 4px !important;
          background: #ffffff !important;
          cursor: pointer !important;
          appearance: auto !important;
          -webkit-appearance: checkbox !important;
        }

        .quick-dialog-overlay {
          position: fixed;
          inset: 0;
          z-index: 1100;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(15, 23, 42, 0.45);
        }

        .quick-dialog-card {
          width: calc(100% - 32px);
          max-width: 400px;
          padding: 20px;
          border-radius: 14px;
          background: #fff;
          color: #1e293b;
          box-shadow: 0 16px 40px rgba(0, 0, 0, 0.2);
        }

        .quick-dialog-card h3 { margin: 0 0 18px; }
        .quick-dialog-card select {
          width: 100%;
          margin: 6px 0 16px;
          padding: 10px;
          border: 1px solid #cbd5e1;
          border-radius: 8px;
          background: #fff;
        }

        .quick-device-search {
          width: 100%;
          margin: 6px 0 16px;
          padding: 10px;
          border: 1px solid #cbd5e1;
          border-radius: 8px;
          background: #fff;
          box-sizing: border-box;
        }

        .quick-device-search:focus,
        .quick-dialog-card select:focus {
          border-color: #006E6E;
          outline: none;
          box-shadow: 0 0 0 3px rgba(0, 110, 110, 0.12);
        }

        .quick-device-field { position: relative; }
        .quick-device-results {
          position: absolute;
          z-index: 5;
          top: calc(100% - 13px);
          left: 0;
          right: 0;
          max-height: 190px;
          overflow-y: auto;
          border: 1px solid #cbd5e1;
          border-radius: 8px;
          background: #fff;
          box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
        }

        .quick-device-option {
          display: flex;
          justify-content: space-between;
          width: 100%;
          padding: 10px 12px;
          border: 0;
          border-bottom: 1px solid #edf2f7;
          background: transparent;
          color: #1e293b;
          text-align: left;
          cursor: pointer;
        }

        .quick-device-option:hover { background: #ecfdfb; }
        .quick-device-option.assigned { color: #94a3b8; cursor: not-allowed; }
        .quick-dialog-cancel,
        .quick-dialog-apply {
          padding: 9px 17px;
          border-radius: 7px;
          font-weight: 600;
          cursor: pointer;
        }
        .quick-dialog-cancel { border: 1px solid #cbd5e1; background: #fff; color: #334155; }
        .quick-dialog-apply { border: none; background: #006E6E; color: #fff; }
        .quick-dialog-apply:disabled { opacity: 0.5; cursor: not-allowed; }

        [data-theme='dark'] .quick-dialog-card {
          background: #111c2f;
          color: #f8fafc;
          border: 1px solid #334155;
        }
        [data-theme='dark'] .quick-dialog-card select,
        [data-theme='dark'] .quick-device-search {
          background: #1e293b;
          color: #f8fafc;
          border-color: #475569;
          color-scheme: dark;
        }
        [data-theme='dark'] .quick-dialog-card select option {
          background: #1e293b;
          color: #f8fafc;
        }
        [data-theme='dark'] .quick-device-search::placeholder {
          color: #94a3b8;
        }
        [data-theme='dark'] .quick-device-results {
          background: #1e293b;
          border-color: #475569;
        }
        [data-theme='dark'] .quick-device-option {
          background: #1e293b;
          color: #f8fafc;
          border-bottom-color: #334155;
        }
        [data-theme='dark'] .quick-device-option:not(:disabled):hover,
        [data-theme='dark'] .quick-device-option:focus-visible { background: #334155; }
        [data-theme='dark'] .quick-device-option.assigned { color: #94a3b8; }
        [data-theme='dark'] .quick-dialog-cancel {
          background: #fff;
          color: #172033;
          border-color: #fff;
        }
        [data-theme='dark'] .quick-dialog-apply {
          background: #fff;
          color: #006E6E;
        }

        .quick-switch {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          margin-left: auto;
          margin-right: 16px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          user-select: none;
        }

        .quick-switch input {
          position: absolute;
          opacity: 0;
          pointer-events: none;
        }

        .quick-switch-track {
          position: relative;
          width: 34px;
          height: 18px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.35);
          border: 1px solid rgba(255, 255, 255, 0.55);
          transition: background 0.2s ease, border-color 0.2s ease;
        }

        .quick-switch-track::after {
          content: '';
          position: absolute;
          top: 2px;
          left: 2px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #fff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
          transition: transform 0.2s ease;
        }

        .quick-switch input:checked + .quick-switch-track {
          background: #5eead4;
          border-color: #99f6e4;
        }

        .quick-switch input:checked + .quick-switch-track::after {
          transform: translateX(16px);
        }

        .quick-switch input:focus-visible + .quick-switch-track {
          box-shadow: 0 0 0 3px rgba(153, 246, 228, 0.45);
        }
      `}</style>

      <div className="client-form-modal client-onboarding-modal" style={{ width: stepperStep > 1 ? '96vw' : undefined, maxWidth: stepperStep > 1 ? '1480px' : '850px', borderRadius: '20px', overflow: 'hidden' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" style={{ background: '#006E6E', color: 'white', display: 'flex', justifyContent: 'space-between', padding: '16px 24px', borderBottom: 'none' }}>
          <h2>{title || (formData.id ? 'Edit Client' : 'Register Client')}</h2>
          {(loggedInUser?.role === 'superadmin' || String(loggedInUser?.dealerId) === '31278' || '276') && !isEditMode && (
            <label className="quick-switch">
              <input type="checkbox" checked={quickAdd} onChange={handleQuickAdd} />
              <span className="quick-switch-track" aria-hidden="true"></span>
              <span>Testing</span>
            </label>
          )}
          <button className="modal-close" style={{ color: 'white', background: 'transparent', fontSize: '20px' }} onClick={onClose}>✕</button>
        </div>

        {validationMessage && (
          <div role="alert" style={{ margin: '16px 24px 0', padding: '11px 14px', borderRadius: '8px', color: '#991b1b', background: '#fef2f2', border: '1px solid #fecaca', fontSize: '13px', fontWeight: 600 }}>
            {validationMessage}
          </div>
        )}

        {quickDialog && (
          <div className="quick-dialog-overlay" onClick={closeQuickAddDialog}>
            <div className="quick-dialog-card" onClick={(event) => event.stopPropagation()}>
              <h3>Select Facility &amp; Device</h3>
              <label>Select Facility</label>
              <select value={quickFacility} onChange={(event) => setQuickFacility(event.target.value)}>
                <option value="">Select Facility</option>
                {availableOffices.map(office => (
                  <option key={office.officeId} value={office.officeId}>{office.officeName}</option>
                ))}
              </select>

              <label>Select Device</label>
              <div className="quick-device-field">
                <input
                  className="quick-device-search"
                  style={{ textTransform: 'uppercase' }}
                  type="search"
                  value={quickDevice}
                  onFocus={() => setShowQuickDeviceDropdown(true)}
                  onChange={(event) => {
                    setQuickDevice(event.target.value);
                    setShowQuickDeviceDropdown(true);
                  }}
                  placeholder="Search device serial number"
                  autoComplete="off"
                />
                {showQuickDeviceDropdown && (
                  <div className="quick-device-results">
                    {filteredQuickDevices.length > 0 ? filteredQuickDevices.slice(0, 50).map(device => {
                      const assigned = isDeviceAlreadyAssigned(device.sno);
                      return (
                        <button
                          type="button"
                          key={device.sno}
                          className={`quick-device-option ${assigned ? 'assigned' : ''}`}
                          disabled={assigned}
                          onClick={() => {
                            setQuickDevice(device.sno);
                            setShowQuickDeviceDropdown(false);
                          }}
                        >
                          <span>{String(device.sno || '').toUpperCase()}</span>
                          {assigned && <small>Already assigned</small>}
                        </button>
                      );
                    }) : (
                      <div className="quick-device-option">No devices found</div>
                    )}
                  </div>
                )}
              </div>
              {isDeviceAlreadyAssigned(quickDevice) && (
                <span className="error-text" style={{ display: 'block', marginTop: '-10px', marginBottom: '14px' }}>
                  This Number already exists use different one
                </span>
              )}

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '8px' }}>
                <button className="quick-dialog-cancel" type="button" onClick={closeQuickAddDialog}>Cancel</button>
                <button className="quick-dialog-apply" type="button" onClick={applyQuickData} disabled={!quickFacility || !devices.some(device => device.sno === quickDevice) || isDeviceAlreadyAssigned(quickDevice)}>Apply</button>
              </div>
            </div>
          </div>
        )}

        {/* Stepper Header (All dealers in Add mode) */}
        {!isEditMode && (
          <nav className="client-stepper-header onboarding-steps" aria-label="Client onboarding progress">
            {['Client details', 'Document form', 'Installation form', 'Invoices', 'Complete'].map((label, index) => (
              <div key={label} className={`stepper-step ${stepperStep === index + 1 ? 'active' : ''} ${stepperStep > index + 1 ? 'completed' : ''}`} aria-current={stepperStep === index + 1 ? 'step' : undefined}>
                <span className="step-num">{index + 1}</span><span className="step-label">{label}</span>
              </div>
            ))}
          </nav>
        )}

        <div className="client-form" style={{ padding: '0px' }}>
          <div ref={formBodyRef} className={`form-body ${stepperStep === 2 ? 'acs-form-body' : ''}`} style={{ maxHeight: '70vh', overflowY: 'auto', padding: '24px' }}>

            {/* STEP 1: CLIENT DETAILS */}
            {stepperStep === 1 && (
              <>
                {/* Basic Information Section */}
                <div className="form-section">
                  <h3>Basic Information</h3>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="required">Name (FIRST/MIDDLE/LAST)*</label>
                      <input
                        type="text"
                        name="client"
                        value={formData.client}
                        onChange={handleInputChange}
                        className={errors.client ? 'error-input' : ''}
                        placeholder="Name(FIRST/MIDDLE/LAST)*"
                      />
                      {errors.client && <span className="error-text">{errors.client}</span>}
                    </div>

                    <div className="form-group">
                      <label className="required">Home Telephone*</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <select
                          value={phoneCountryCode}
                          onChange={(event) => setPhoneCountryCode(event.target.value)}
                          aria-label="Country code"
                          style={{ flex: '0 0 78px' }}
                        >
                          {['+91', '+1', '+44', '+61', '+971', phoneCountryCode]
                            .filter((code, index, codes) => codes.indexOf(code) === index)
                            .map(code => <option key={code} value={code}>{code}</option>)}
                        </select>
                        <input
                          type="tel"
                          name="clientphone1"
                          value={formData.clientphone1}
                          onChange={handleInputChange}
                          maxLength={10}
                          className={errors.clientphone1 ? 'error-input' : ''}
                          placeholder="Home Telephone*"
                          style={{ flex: 1 }}
                        />
                      </div>
                      <small style={{ color: '#64748b', display: 'block', marginTop: '4px' }}></small>
                      {errors.clientphone1 && <span className="error-text">{errors.clientphone1}</span>}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className={errors.email ? 'error-input' : ''}
                        placeholder="Email"
                      />
                      {errors.email && <span className="error-text">{errors.email}</span>}
                    </div>

                    <div className="form-group">
                      <label>Date of Birth</label>
                      <div className="date-input-wrapper">
                        <DatePicker
                          selected={parseMMDDYYYY(formData.dob)}
                          onChange={(date) => handleDateChange(date, 'dob')}
                          dateFormat="MM/dd/yyyy"
                          placeholderText="Date Of Birth"
                          className={errors.dob ? 'error-input' : ''}
                          showYearDropdown
                          scrollableYearDropdown
                          yearDropdownItemNumber={100}
                          maxDate={new Date()}
                        />
                      </div>
                      {errors.dob && <span className="error-text">{errors.dob}</span>}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Driving Licence</label>
                      <input
                        type="text"
                        name="dlnum"
                        value={formData.dlnum}
                        onChange={handleInputChange}
                        // className={errors.dlnum ? 'error-input' : ''}
                        placeholder="Driving Licence"
                      />
                      {/* {errors.dlnum && <span className="error-text">{errors.dlnum}</span>} */}
                    </div>
                  </div>
                </div>

                {/* Mailing Address Section */}
                <div className="form-section">
                  <h3>Mailing Address</h3>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Mailing Address</label>
                      <input
                        type="text"
                        name="clientAddress"
                        value={formData.clientAddress}
                        onChange={handleInputChange}
                        placeholder="Mailing Address"
                      />
                    </div>

                    <div className="form-group">
                      <label>Apartment/Space Number</label>
                      <input
                        type="text"
                        name="space"
                        value={formData.space}
                        onChange={handleInputChange}
                        placeholder="Appartment/Space Number"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>City</label>
                      <input
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        placeholder="City"
                      />
                    </div>

                    <div className="form-group">
                      <label>State</label>
                      <select
                        name="state"
                        value={formData.state}
                        onChange={handleInputChange}
                        className={errors.state ? 'error-input' : ''}
                      >
                        <option value="">Select State</option>
                        {states.map(st => {
                          const value = st.state || st;
                          return <option key={value} value={value}>{st.name || value}</option>;
                        })}
                      </select>
                      {errors.state && <span className="error-text">{errors.state}</span>}
                    </div>

                    <div className="form-group">
                      <label>Zip Code</label>
                      <input
                        type="text"
                        name="zipcode"
                        value={formData.zipcode}
                        onChange={handleInputChange}
                        maxLength={5}
                        className={errors.zipcode ? 'error-input' : ''}
                        placeholder="Zip"
                      />
                      {errors.zipcode && <span className="error-text">{errors.zipcode}</span>}
                    </div>
                  </div>
                </div>

                {/* Manufacturer/Facility Details Section */}
                <div className="form-section">
                  <h3>Manufacturer/Facility Details</h3>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="required">Select Facility*</label>
                      <div className="searchable-select" ref={officeDropdownRef}>
                        <input
                          type="text"
                          value={officeSearchTerm || formData.officeName}
                          onClick={() => setShowOfficeDropdown(!showOfficeDropdown)}
                          onChange={(e) => {
                            setOfficeSearchTerm(e.target.value);
                            setShowOfficeDropdown(true);
                            if (e.target.value === '') {
                              setFormData(prev => ({ ...prev, officeId: '', officeName: '', officelicensenumber: '', faddress: '', fcity: '', fstate: '', fzipcode: '' }));
                            }
                          }}
                          placeholder="Select Facility*"
                          className={errors.officeId ? 'error-input' : ''}
                        />
                        {showOfficeDropdown && (
                          <div className="searchable-dropdown">
                            {filteredOffices.length > 0 ? (
                              filteredOffices.map(office => (
                                <div
                                  key={office.officeId}
                                  className="dropdown-item"
                                  onClick={() => handleOfficeSelect(office.officeId, office.officeName)}
                                >
                                  {office.officeName}
                                </div>
                              ))
                            ) : (
                              <div className="dropdown-item no-results">No facilities found</div>
                            )}
                          </div>
                        )}
                      </div>
                      {errors.officeId && <span className="error-text">{errors.officeId}</span>}
                    </div>
                  </div>

                  {formData.officeId && (
                    <>
                      <div className="form-row">
                        <div className="form-group">
                          <label>{formData.isbar === '1' ? 'BAR License' : 'BEARHFTI License'}</label>
                          <input
                            type="text"
                            value={formData.officelicensenumber}
                            disabled
                            className="readonly-field"
                          />
                        </div>
                        <div className="form-group">
                          <label>Facility Address*</label>
                          <input
                            type="text"
                            value={formData.faddress}
                            disabled
                            className="readonly-field"
                          />
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group">
                          <label>City</label>
                          <input
                            type="text"
                            value={formData.fcity}
                            disabled
                            className="readonly-field"
                          />
                        </div>
                        <div className="form-group">
                          <label>State</label>
                          <input
                            type="text"
                            value={formData.fstate}
                            disabled
                            className="readonly-field"
                          />
                        </div>
                        <div className="form-group">
                          <label>Zip</label>
                          <input
                            type="text"
                            value={formData.fzipcode}
                            disabled
                            className="readonly-field"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Device & Vehicle Details Section */}
                <div className="form-section">
                  <h3>Device & Vehicle Details</h3>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="required">Select Device*</label>
                      <div className="searchable-select" ref={deviceDropdownRef}>
                        <input
                          type="text"
                          value={deviceSearchTerm || formData.sno}
                          onClick={() => setShowDeviceDropdown(!showDeviceDropdown)}
                          onChange={(e) => {
                            setDeviceSearchTerm(e.target.value);
                            setShowDeviceDropdown(true);
                            setFormData(prev => ({ ...prev, sno: '' }));
                            if (errors.sno) setErrors(prev => ({ ...prev, sno: '' }));
                          }}
                          placeholder="Select Device"
                          className={errors.sno ? 'error-input' : ''}
                        />
                        {showDeviceDropdown && (
                          <div className="searchable-dropdown">
                            {filteredDevices.length > 0 ? (
                              filteredDevices.map(device => (
                                <div
                                  key={device.sno}
                                  className="dropdown-item"
                                  onClick={() => handleDeviceSelect(device.sno)}
                                >
                                  {String(device.sno || '').toUpperCase()}
                                  {isDeviceAlreadyAssigned(device.sno) && ' (Already assigned)'}
                                </div>
                              ))
                            ) : (
                              <div className="dropdown-item no-results">No devices found</div>
                            )}
                          </div>
                        )}
                      </div>
                      {errors.sno && <span className="error-text">{errors.sno}</span>}
                    </div>

                    <div className="form-group">
                      <label>License Plate Number</label>
                      <input
                        type="text"
                        name="regnum"
                        value={formData.regnum}
                        onChange={handleInputChange}
                        className={errors.regnum ? 'error-input' : ''}
                        placeholder="License Plate Number"
                      />
                      {errors.regnum && <span className="error-text">{errors.regnum}</span>}
                    </div>
                  </div>

                  {isEditMode && (
  <>
    <div className="form-row">
      <div className="form-group">
        <label>Vehicle Make</label>
        <input
          type="text"
          name="make"
          value={formData.make || ''}
          onChange={handleInputChange}
          placeholder="Vehicle Make"
        />
      </div>

      <div className="form-group">
        <label>Vehicle Model</label>
        <input
          type="text"
          name="model"
          value={formData.model || ''}
          onChange={handleInputChange}
          placeholder="Vehicle Model"
        />
      </div>

      <div className="form-group">
        <label>Model Year</label>
        <input
          type="text"
          name="year"
          value={formData.year || ''}
          onChange={handleInputChange}
          placeholder="Model Year"
          maxLength={4}
        />
      </div>
    </div>

    <div className="form-row">
      <div className="form-group">
        <label>VIN Number</label>
        <input
          type="text"
          name="vin"
          value={formData.vin || ''}
          onChange={handleInputChange}
          placeholder="VIN Number"
        />
      </div>

      <div className="form-group">
        <label>Prohibition Number</label>
        <input
          type="text"
          name="prohibitionnumber"
          value={formData.prohibitionnumber || ''}
          onChange={handleInputChange}
          placeholder="Prohibition Number"
        />
      </div>
    </div>
  </>
)}

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="client-tag-state">Tag State</label>
                      <Select
                        inputId="client-tag-state"
                        name="tagstate"
                        options={states.map(st => ({ value: st.state || st, label: st.name || st.state || st }))}
                        value={formData.tagstate ? {
                          value: formData.tagstate,
                          label: states.find(st => (st.state || st) === formData.tagstate)?.name || formData.tagstate,
                        } : null}
                        onChange={option => handleTagStateChange({ target: { value: option?.value || '' } })}
                        isSearchable
                        placeholder="Search tag state..."
                        noOptionsMessage={() => 'No states found'}
                        filterOption={(option, input) => `${option.label} ${option.value}`.toLowerCase().includes(input.toLowerCase())}
                        className={errors.tagstate ? 'error-input' : ''}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          control: base => ({ ...base, background: 'var(--bg-secondary)', borderColor: errors.tagstate ? '#dc2626' : 'var(--border-light)', minHeight: 40 }),
                          singleValue: base => ({ ...base, color: 'var(--text-primary)' }),
                          input: base => ({ ...base, color: 'var(--text-primary)' }),
                          menu: base => ({ ...base, background: 'var(--bg-secondary)', color: 'var(--text-primary)' }),
                          option: (base, state) => ({ ...base, background: state.isSelected ? '#2d6a4f' : state.isFocused ? 'var(--bg-tertiary)' : 'transparent', color: state.isSelected ? '#fff' : 'var(--text-primary)' }),
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                      {errors.tagstate && <span className="error-text">{errors.tagstate}</span>}
                    </div>

                    <div className="form-group">
                      <label>Calibration Period</label>
                      <select
                        name="calibrationperiod"
                        value={formData.calibrationperiod}
                        disabled
                        className={errors.calibrationperiod ? 'error-input' : ''}
                      >
                        <option value="">Select Period</option>
                        {[...new Set([...calibrationPeriods, formData.calibrationperiod].filter(Boolean))].map(period => (
                          <option key={period} value={period}>{period} days</option>
                        ))}
                      </select>
                      {errors.calibrationperiod && <span className="error-text">{errors.calibrationperiod}</span>}
                    </div>
                  </div>

                  {formData.calibrationperiod && (
                    <div className="form-row">
                      <div className="form-group">
                        <label className="required">Install Date*</label>
                        <div className="date-input-wrapper">
                          <DatePicker
                            selected={parseMMDDYYYY(formData.installDate)}
                            onChange={(date) => handleDateChange(date, 'installDate')}
                            dateFormat="MM/dd/yyyy"
                            placeholderText="Install Date"
                            className={errors.installDate ? 'error-input' : ''}
                            maxDate={new Date()}
                          />
                        </div>
                        {errors.installDate && <span className="error-text">{errors.installDate}</span>}
                      </div>

                      <div className="form-group">
                        <label>Calibration Date</label>
                        <input
                          type="text"
                          value={formData.calibrationDate}
                          readOnly
                          disabled
                          className="readonly-field"
                        />
                      </div>

                      <div className="form-group">
                        <label>Date of Next Monitor Check</label>
                        <input
                          type="text"
                          value={formData.nextcmonitordate}
                          readOnly
                          disabled
                          className="readonly-field"
                        />
                      </div>
                    </div>
                  )}
                </div>

                {/* Facility Inspection Section */}
                <div className="form-section">
                  <h3>Facility Inspection</h3>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="required">Installation Date*</label>
                      <div className="date-input-wrapper">
                        <DatePicker
                          selected={parseMMDDYYYY(formData.installDate)}
                          onChange={(date) => handleDateChange(date, 'installDate')}
                          dateFormat="MM/dd/yyyy"
                          placeholderText="Installation Date*"
                          className={errors.installDate ? 'error-input' : ''}
                          maxDate={new Date()}
                        />
                      </div>
                      {errors.installDate && <span className="error-text">{errors.installDate}</span>}
                    </div>

                    <div className="form-group">
                      <label>Select Installer</label>
                      <div className="searchable-select" ref={installerDropdownRef}>
                        <input
                          type="text"
                          value={installerSearchTerm || formData.installerName}
                          onClick={() => setShowInstallerDropdown(!showInstallerDropdown)}
                          onChange={(e) => {
                            setInstallerSearchTerm(e.target.value);
                            setShowInstallerDropdown(true);
                            if (e.target.value === '') {
                              setFormData(prev => ({ ...prev, installer: '', installerName: ''}));
                            }
                          }}
                          placeholder="Select Installer"
                          className={errors.installer ? 'error-input' : ''}
                        />
                        {showInstallerDropdown && (
                          <div className="searchable-dropdown">
                            {filteredUsers.length > 0 ? (
                              filteredUsers.map(user => (
                                <div
                                  key={user.userId}
                                  className="dropdown-item"
                                  onClick={() => handleInstallerSelect(user.userId, user.userName)}
                                >
                                  {user.userName}
                                </div>
                              ))
                            ) : (
                              <div className="dropdown-item no-results">No installers found</div>
                            )}
                          </div>
                        )}
                      </div>
                      {errors.installer && <span className="error-text">{errors.installer}</span>}
                    </div>
                  </div>

                  {/* {formData.installer && (
                    <div className="form-row">
                      <div className="form-group">
                        <label>Installer Mobile</label>
                        <input
                          type="text"
                          value={formData.imobile}
                          readOnly
                          disabled
                          className="readonly-field"
                        />
                      </div>
                    </div>
                  )} */}

                  <div className="form-group checkbox-group" style={{ marginTop: '16px' }}>
                    <label>
                      <input
                        type="checkbox"
                        name="isinstalledandworking"
                        checked={formData.isinstalledandworking === '1'}
                        onChange={handleInputChange}
                      />
                      Working Device is installed in the above vehicle
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="driverisincompliance"
                        checked={formData.driverisincompliance === '1'}
                        onChange={handleInputChange}
                      />
                      Above Driver is in compliance with the device maintenance and calibration requirements
                    </label>
                  </div>

                  {/* {!isEditMode && (
                    <div className="form-group checkbox-group" style={{ borderTop: '1px solid #e2e8f0', paddingTop: '16px', marginTop: '16px' }}>
                      <label style={{ color: '#006E6E', fontWeight: 'bold' }}>
                        <input
                          type="checkbox"
                          checked={stepperAddInvoice}
                          onChange={(e) => setStepperAddInvoice(e.target.checked)}
                        />
                        Enable Payments Details
                      </label>
                    </div>
                  )} */}
                </div>
              </>
            )}

{/* =========================================================
    STEP 2: CUSTOMER LEASE AGREEMENT
========================================================= */}

{isOpen && acsClientId && (
  <div className="acs-step-panel" hidden={stepperStep !== 2}>
    <ClientAgreements clientid={acsClientId} dealerid={onboardingDealerId} client={formData}
      onBack={() => setStepperStep(1)} onComplete={goToStep3}
      onClientSignatureSaved={signature => {
        if (!invoiceSignatureEditedRef.current) setInvoiceClientSignature(current => current || signature);
      }} />
  </div>
)}

          {stepperStep === 3 && acsClientId && (
            <section className="client-onboarding-installation" aria-label="Installation form step">
              <p>Save the installation acknowledgement to continue to invoices. Close returns to ACS forms.</p>
              <InstallationForm clientId={installationClient}
                onSuccess={() => { setInstallationSaved(true); setStepperStep(4); }} onClose={() => setStepperStep(2)} />
            </section>
          )}
          {/* =========================================================
    STEP 4: INVOICES CONFIGURATION
========================================================= */}
{stepperStep === 4 &&
  !isEditMode && (

  <div className="invoice-workspace"
    style={{
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
      gap: '20px',
      alignItems: 'start',
    }}
  >

    {/* =====================================================
        LEFT SIDE - INVOICE CONFIGURATION
    ===================================================== */}
    <div
      className="price-config-card"
      style={{
        overflowY: 'auto',
        paddingRight: '15px',
      }}
    >
      <h3 className="price-config-title">
        Configure Invoice
      </h3>

      {/* Billing Product */}
      <div
        className="form-group"
        style={{ marginBottom: '20px' }}
      >
        <label>Billing Product</label>

        <input
          type="text"
          value="A200 Monthly"
          disabled
          className="readonly-field"
          style={{
            background: '#f8fafc',
          }}
        />
      </div>

      {/* Price Plan */}
      <div className="price-select-wrapper">
        <label>Select Price Plan</label>

        <div className="price-select-control">
          <select
            className="price-select-input"
            value={selectedPrice}
            onChange={(e) => {
              if (e.target.value === 'ADD_NEW') {
                setPriceDialog(true);
                setSelectedPrice('');
              } else {
                setSelectedPrice(e.target.value);
              }
            }}
            style={{
              width: '100%',
            }}
          >
            <option value="" disabled>
              Select Existing Price
            </option>

            {prices.map((p) => (
              <option
                key={p.id}
                value={p.id}
              >
                {p.display}
              </option>
            ))}

            <option
              value="ADD_NEW"
              style={{
                fontWeight: 'bold',
                color: '#006E6E',
              }}
            >
              + Add New Price
            </option>
          </select>
        </div>
      </div>

      {/* =============================================
          Installation + Device Usage
      ============================================= */}
      <div
        className="form-row"
        style={{ marginTop: '24px' }}
      >
        <div className="form-group">
          <label>
            Installation Charges ($)
          </label>

          <input
            type="number"
            value={installationCharges}
            onChange={(e) =>
              setInstallationCharges(e.target.value)
            }
            onKeyDown={(e) =>
              ['e', 'E', '.', '-'].includes(e.key) &&
              e.preventDefault()
            }
            step="1"
            placeholder="$"
          />
        </div>

        <div className="form-group">
          <label>
            Device Usage Fee ($)
          </label>

          <input
            type="number"
            value={deviceUsage}
            onChange={(e) =>
              setDeviceUsage(e.target.value)
            }
            onKeyDown={(e) =>
              ['e', 'E', '.', '-'].includes(e.key) &&
              e.preventDefault()
            }
            step="1"
            placeholder="$"
          />
        </div>
      </div>

      {/* =============================================
          Calibration + Device Lost
      ============================================= */}
      <div className="form-row">

        <div className="form-group">
          <label>
            Calibration Charges ($)
          </label>

          <input
            type="number"
            value={calibrationCharges}
            onChange={(e) =>
              setCalibrationCharges(e.target.value)
            }
            onKeyDown={(e) =>
              ['e', 'E', '.', '-'].includes(e.key) &&
              e.preventDefault()
            }
            step="1"
            placeholder="$"
          />
        </div>

        <div className="form-group">
          <label>
            Device Lost Fee ($)
          </label>

          <input
            type="number"
            value={deviceLost}
            onChange={(e) =>
              setDeviceLost(e.target.value)
            }
            onKeyDown={(e) =>
              ['e', 'E', '.', '-'].includes(e.key) &&
              e.preventDefault()
            }
            step="1"
            placeholder="$"
          />
        </div>

      </div>

      {/* =============================================
          Physical Damage + Late Payment
      ============================================= */}
      <div className="form-row">

        <div className="form-group">
          <label>
            Physical Damage ($)
          </label>

          <input
            type="number"
            value={physicalDamage}
            onChange={(e) =>
              setPhysicalDamage(e.target.value)
            }
            onKeyDown={(e) =>
              ['e', 'E', '.', '-'].includes(e.key) &&
              e.preventDefault()
            }
            step="1"
            placeholder="$"
          />
        </div>

        <div className="form-group">
          <label>
            Late Payment Fee ($)
          </label>

          <input
            type="number"
            value={latePaymentfee}
            onChange={(e) =>
              setLatePaymentfee(e.target.value)
            }
            onKeyDown={(e) =>
              ['e', 'E', '.', '-'].includes(e.key) &&
              e.preventDefault()
            }
            step="1"
            placeholder="$"
          />
        </div>

      </div>

      {/* =============================================
          Insurance + Removal Charges
      ============================================= */}
      <div className="form-row">

        <div
          className="form-group"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >

            <input
              type="checkbox"
              id="enable-insurance"
              checked={enableInsurancePayment}
              onChange={(e) => {
                setEnableInsurancePayment(
                  e.target.checked
                );

                setInsurancePaymentfee(
                  e.target.checked
                    ? insurancePaymentfee
                    : '0'
                );
              }}
            />

            <label
              htmlFor="enable-insurance"
              style={{
                color: '#006E6E',
                fontWeight: '600',
                margin: 0,
              }}
            >
              Enable Insurance Fee
            </label>

          </div>

          <input
            type="number"
            value={insurancePaymentfee}
            onChange={(e) =>
              setInsurancePaymentfee(
                e.target.value
              )
            }
            disabled={!enableInsurancePayment}
            onKeyDown={(e) =>
              ['e', 'E', '.', '-'].includes(e.key) &&
              e.preventDefault()
            }
            step="1"
            placeholder="$"
          />

        </div>

        <div className="form-group">
          <label>
            Removal Charges ($)
          </label>

          <input
            type="number"
            value={removalCharges}
            onChange={(e) =>
              setRemovalCharges(e.target.value)
            }
            onKeyDown={(e) =>
              ['e', 'E', '.', '-'].includes(e.key) &&
              e.preventDefault()
            }
            step="1"
            placeholder="$"
          />
        </div>

      </div>

      <div className="acs-wizard invoice-signatures">
        <fieldset disabled={invoiceSaving}>
          <div className="acs-signatures">
            <SignatureField label="Invoice authorization signature" value={invoiceAuthSignature} onChange={setInvoiceAuthSignature}
              defaultSignature="/rampalyam.png" onRestore={() => setInvoiceAuthSignature('/rampalyam.png')} />
            <SignatureField label="Invoice client signature" value={invoiceClientSignature} onChange={signature => { invoiceSignatureEditedRef.current = true; setInvoiceClientSignature(signature); }} />
          </div>
        </fieldset>
        {invoiceMessage && <div className={`acs-message ${invoiceMessage.error ? 'acs-error' : ''}`} role={invoiceMessage.error ? 'alert' : 'status'}>{invoiceMessage.text}</div>}
      </div>
    </div>


    {/* =====================================================
        RIGHT SIDE - PAYMENT AGREEMENT

        TEMPORARY:
        Uses the saved client ID
        devicetype = interlock
    ===================================================== */}
    <div
      style={{
        border: '1px solid #dcdcdc',
        borderRadius: '8px',
        backgroundColor: '#ffffff',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '480px',
      }}
    >

      {/* =============================================
          AGREEMENT HEADER
      ============================================= */}
      <div
        style={{
          padding: '12px 16px',
          borderBottom: '1px solid #dcdcdc',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#f8f9fa',
        }}
      >

        <div>
          <strong>
            Payment Agreement
          </strong>

          <div
            style={{
              fontSize: '12px',
              color: '#777',
              marginTop: '2px',
            }}
          >
            Client ID: {acsClientId}
          </div>
        </div>

        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          style={{
    opacity: 1,
    cursor: 'pointer',
    color: '#0d6efd',
    borderColor: '#0d6efd',
    background: 'transparent'
  }}
          onClick={() =>
            window.open(
              `https://robopower.xyz/v2/stripepayments/getpaymentagreement?clientid=${encodeURIComponent(acsClientId)}&devicetype=interlock`,
              '_blank'
            )
          }
        >
          Open Full Page
        </button>

      </div>


      {/* =============================================
          3-PAGE PAYMENT AGREEMENT
      ============================================= */}
      <FormPdfPreview
        title="Payment Agreement"
        key={invoiceRevision}
        src={`https://robopower.xyz/v2/stripepayments/getpaymentagreement?clientid=${encodeURIComponent(acsClientId)}&devicetype=interlock&_revision=${invoiceRevision}`}
      />

    </div>

  </div>
)}
            {stepperStep === 5 && !isEditMode && (
              <section className="client-completion-summary">
                <header className="completion-heading">
                  <span className="completion-check" aria-hidden="true">✓</span>
                  <div><h3>Ready to complete</h3><p>Review the client details and select Complete to finish.</p></div>
                </header>
                <div className="completion-statuses" aria-label="Onboarding status">
                  <span>Document forms saved</span>
                  <span>Installation {installationSaved ? 'saved' : 'pending'}</span>
                  <span>Invoice {invoiceSaved ? 'saved' : 'pending'}</span>
                </div>
                <dl>{[['Name', formData.client], ['Installation date', formData.installDate], ['Device S/No.', formData.sno]].map(([label, value]) => (
                  <div key={label}><dt>{label}</dt><dd>{value || 'Not provided'}</dd></div>
                ))}</dl>
              </section>
            )}

          </div>

          <div hidden={stepperStep === 2} className="form-footer" style={{ borderTop: '1px solid #e2e8f0', padding: '16px 24px', background: '#f8fafc' }}>
            {stepperStep === 3 && (
              <>
                <button type="button" className="btn-cancel"  style={{
    background: '#334155',
    color: '#fff',
    border: '1px solid #475569',
    opacity: 1,
    cursor: 'pointer'
  }}onClick={() => setStepperStep(2)}>Back to Document Form</button>
                {installationSaved && <button type="button" className="btn-submit" onClick={() => setStepperStep(4)}>
                  Continue to invoices
                </button>}
              </>
            )}
            {/* Step 1 Actions */}
            {stepperStep === 1 && (
              <>
                <button type="button" className="btn-cancel" onClick={onClose} style={{ background: '#ff3d41', color: 'white', border: 'none', borderRadius: '20px', padding: '10px 24px' }}>
                  Cancel
                </button>
                {!isEditMode ? (
                  <button type="button" className="btn-submit" onClick={goToStep2} disabled={stepperLoading} style={{ background: '#006E6E', color: 'white', border: 'none', borderRadius: '20px', padding: '10px 24px' }}>
                    {stepperLoading ? 'Saving client...' : acsClientId ? 'Save & return to Document Form' : 'Create client & continue'}
                  </button>
                ) : (
                  <button type="button" className="btn-submit" onClick={submitStepper} disabled={stepperLoading} style={{ background: '#10b981', color: 'white', border: 'none', borderRadius: '20px', padding: '10px 24px' }}>
                    {stepperLoading ? 'Submitting...' : (isEditMode ? 'Update' : 'Submit')}
                  </button>
                )}
              </>
            )}

            {/* Step 3 Actions */}
            {stepperStep === 4 && !isEditMode && (
              <>
                <button type="button" className="btn-cancel" onClick={() => setStepperStep(3)} style={{ background: 'transparent', border: '1px solid #d1d5db', color: '#374151', borderRadius: '20px', padding: '10px 24px' }}>
                  Back
                </button>
                <button type="button" className="btn-submit" disabled={invoiceSaving} onClick={saveInvoice}>{invoiceSaving ? 'Saving...' : 'Save invoice agreement'}</button>
                {invoiceSaved && <button type="button" className="btn-submit" onClick={goToStep4}>Continue</button>}
              </>
            )}

            {/* Step 4 Actions */}
            {stepperStep === 5 && !isEditMode && (
              <>
                <button type="button" className="btn-cancel" onClick={() => setStepperStep(4)} style={{ background: 'transparent', border: '1px solid #d1d5db', color: '#374151', borderRadius: '20px', padding: '10px 24px' }} disabled={stepperLoading}>
                  Back
                </button>
                <button type="button" className="btn-submit" onClick={submitStepper} disabled={stepperLoading} style={{ background: '#10b981', color: 'white', border: 'none', borderRadius: '20px', padding: '10px 24px' }}>
                  {stepperLoading ? 'Saving...' : 'Complete'}
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* POPUP DIALOG FOR ADDING A NEW PRICE DYNAMICALLY */}
      {priceDialog && (
        <div className="price-modal-overlay" onClick={() => setPriceDialog(false)}>
          <div className="price-modal-card" onClick={(e) => e.stopPropagation()}>
            <h3 className="price-modal-header">Add New Price</h3>
            <div className="price-modal-body">
              <label style={{ fontSize: '13px', fontWeight: '600', color: '#4b5563' }}>Enter Price ($)</label>
              <input
                type="number"
                value={customPrice}
                onChange={(e) => setCustomPrice(e.target.value)}
                placeholder="Enter Price Plan"
              />
            </div>
            <div className="price-modal-footer">
              <button className="btn-price-cancel" onClick={() => setPriceDialog(false)}>Cancel</button>
              <button className="btn-price-save" onClick={createNewPrice}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddEditClient;
